export default __webpack_public_path__ + "static/media/login.74c8fe5d.svg";